import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "flex gap-2 mb-2" }
const _hoisted_3 = { class: "text-xs text-right text-gray-400 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_EditorContent = _resolveComponent("EditorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseLabel, {
      forAttr: "custom-message",
      text: "Custom Message",
      labelClasses: _ctx.labelClasses
    }, null, 8, ["labelClasses"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editor.chain().focus().toggleBold().run())),
        class: _normalizeClass([
          'px-2 py-1 rounded',
          _ctx.editor.isActive('bold') ? 'font-bold text-blue-600 bg-blue-50' : '',
        ]),
        title: "Bold"
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "font-bold" }, "B", -1)
      ]), 2),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run())),
        class: _normalizeClass([
          'px-2 py-1 rounded',
          _ctx.editor.isActive('italic') ? 'italic text-blue-600 bg-blue-50' : '',
        ]),
        title: "Italic"
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("span", { class: "italic" }, "I", -1)
      ]), 2),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editor.chain().focus().toggleStrike().run())),
        class: _normalizeClass([
          'px-2 py-1 rounded',
          _ctx.editor.isActive('strike')
            ? 'line-through text-blue-600 bg-blue-50'
            : '',
        ]),
        title: "Strikethrough"
      }, _cache[8] || (_cache[8] = [
        _createElementVNode("span", { class: "line-through" }, "S", -1)
      ]), 2),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editor.chain().focus().toggleBulletList().run())),
        class: _normalizeClass([
          'px-2 py-1 rounded',
          _ctx.editor.isActive('bulletList') ? 'text-blue-600 bg-blue-50' : '',
        ]),
        title: "Bullet List"
      }, " • List ", 2),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editor.chain().focus().undo().run())),
        class: "px-2 py-1 rounded",
        title: "Undo"
      }, " ⎌ "),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editor.chain().focus().redo().run())),
        class: "px-2 py-1 rounded",
        title: "Redo"
      }, " ↻ ")
    ]),
    _createVNode(_component_EditorContent, {
      editor: _ctx.editor,
      class: "tiptap border border-gray-200 rounded bg-gray-50 min-h-[120px] px-3 py-2 font-sans text-[18px] leading-7 [&_*]:font-sans [&_*]:text-[18px] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:mb-1"
    }, null, 8, ["editor"]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.charCount) + " / 500 characters ", 1)
  ]))
}